import { MediaItem } from "@rapid/types/media";
import { useMediaStore } from "@rapid/store";

/**
 * Hook to get fresh media item data from the store, ensuring progress updates are reflected.
 * This is necessary because components may receive stale mediaItem props from parent components.
 *
 * @param mediaItem - The media item from props (may be stale)
 * @returns Fresh media item data from the store with latest progress/phase information
 */
export function useMediaItemWithProgress(mediaItem: MediaItem): MediaItem {
    const mediaStore = useMediaStore();

    // Get fresh data from store to ensure progress updates are reflected
    return mediaStore[mediaItem.id] || mediaItem;
}

/**
 * Hook to get props for ThumbnailContent with progress tracking
 */
export function useThumbnailProgressProps(mediaItem: MediaItem) {
    const freshMediaItem = useMediaItemWithProgress(mediaItem);

    return {
        freshMediaItem,
        uploadProgress: freshMediaItem.progress,
        uploadPhaseText: freshMediaItem.uploadPhaseText
    };
}
